export interface LoginRequest {
  usernameOrEmail: string
  password: string
  rememberMe?: boolean
}

export interface ChangePasswordRequest {
  currentPassword: string
  newPassword: string
}

export interface LoginResponse {
  token: {
    accessToken: string
    refreshToken: string
    accessExpiresIn: number
    refreshExpiresIn: number
    accessExpiresAt: number
    refreshExpiresAt: number
  }
  user: {
    createdAt: string
    updatedAt: string
    deletedAt: string | null
    id: string
    userName: string
    email: string
    status: string
    role: string
    lastLoginAt: string
    twoFactorEnabled: boolean
    isLinkedGoogle: boolean
  }
  twoFactorRequired?: boolean
  challengeToken?: string
}

export interface Session {
  user?: {
    id: string
    userName: string
    email: string
    role: string
    status: string
    isLinkedGoogle: boolean
  }
  accessToken: string
  accessExpiresIn: number
  accessExpiresAt: number
}

// Role constants
export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  USER: 'user',
} as const

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES]
